import ClientLayout from "../../../components/client/layout/ClientLayout";
import ClientProject from "../../../components/client/project/ClientProject";
import {useParams} from "react-router-dom";

//클라이언트 프로젝트 상세 페이지
const ClientProjectInfoPage: React.FC = () => {
    const {id} = useParams<{ id: string }>();

    //프로젝트 식별자가 없는 경우
    if (!id) {
        return <div>Invalid project ID</div>;
    }

    return (
        <ClientLayout>
            {/*클라이언트 프로젝트 상세 페이지 버튼*/}
            <ClientProject projectId={parseInt(id)}/>
        </ClientLayout>
    );
};

export default ClientProjectInfoPage;